import { render } from "./BoletoGarantidoWeb.vue?vue&type=template&id=28416925&scoped=true"
import script from "./BoletoGarantidoWeb.vue?vue&type=script&lang=js"
export * from "./BoletoGarantidoWeb.vue?vue&type=script&lang=js"

import "./BoletoGarantidoWeb.vue?vue&type=style&index=0&id=28416925&scoped=true&lang=css"

import exportComponent from "/home/devnote/Documentos/Features/Home Creditall/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28416925"]])

export default __exports__